/**
 * L'ultima squadra-stagione aperta, per le viste fuori dal prefisso di
 * squadra. Mister e Dirigente non hanno voci di societa: aperta la scheda di
 * un giocatore o lo storico dell'assistente, il loro guscio resta quello
 * della squadra da cui arrivano, con menu, selettore e barra inferiore.
 *
 * Vive in sessionStorage, quindi resiste a un ricaricamento della pagina ma
 * non passa da una scheda del browser all'altra. Se manca o non vale piu,
 * si ripiega sulla prima squadra della stagione corrente.
 */

import type { SquadraStagione } from './contesto.js';

const CHIAVE = 'ultima-squadra-stagione';

export function ricordaSquadra(ss: string): void {
  try {
    sessionStorage.setItem(CHIAVE, ss);
  } catch {
    // Archivio non disponibile: si ripiega sulla stagione corrente.
  }
}

function ricordata(): string | null {
  try {
    return sessionStorage.getItem(CHIAVE);
  } catch {
    return null;
  }
}

/** La squadra ricordata se e ancora fra le proprie, altrimenti la prima corrente. */
export function squadraDiRiferimento(
  squadre: readonly SquadraStagione[],
  ultima: string | null = ricordata(),
): SquadraStagione | undefined {
  return (
    squadre.find((s) => s.id === ultima) ?? squadre.find((s) => s.stagioneCorrente) ?? squadre[0]
  );
}
